<template>
  <div>
    <!--<div id="welcome" v-if="welcome">-->
    <!--</div>-->
    <!--<Login v-if="showLogin"/>-->
    <div id="app">
      <transition :name="transitionName">
        <navigation>
          <!-- <router-view class="child-view" v-if="showMain" ></router-view> -->
          <keep-alive>
              <router-view class="child-view" v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view  class="child-view" v-if="!$route.meta.keepAlive" />
        </navigation>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { enums } from "./enum";
import {SET_IPFROM} from './store/types'
//    import Login from './modules/Login.vue'
export default {
  name: "App",
  components: {
    //            Login,
  },
  data: function() {
    return {
      transitionName: "none",
      welcome: false
    };
  },
  computed: mapState({
    showMain: function({ user }) {
      return true;
      //                if (this.welcome) return false;
      //                return user.didLogin;
    },
    showLogin: function({ user }) {
      //              return false;
      //                if (this.welcome) return false;
      //                return !user.didLogin;
    }
  }),
  created: function() {
    this.loadYoutubeJs();
    // 显示欢迎页面2s
    if (this.welcome) {
      setTimeout(() => {
        this.welcome = false;
      }, 2000);
    }

    // 判断是pc还是移动端

    // if (
    //   navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    // ) {
    //   // 移动端什么都不做
    // } else {
    //   window.location.href = "https://www.atoshi.org/";
    // }
  },
  watch: {
    $route(to, from) {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // 如果是ios 需要告诉ios 是否显示返回按钮
      // 一级页面 getBackStatus 传递true
      // 一级以后（二三四...） getBackStatus 传递false
      if(to.path != "/")
      {
        // 海外版app 安卓增加返回按钮
        if(isAndroid){
          try{
            window.Android.getBackStatus(true);
          }
          catch(err){
            // console.log("errerrerrerrerr",err)
          }
        }
        // 海外版app ios增加返回按钮
        if(isiOS){
          try{
           window.webkit.messageHandlers.getBackStatus.postMessage(true);
          }
          catch(err){
            // console.log("errerrerrerrerr",err)
          }
        }
      }
      else
      {
        // 海外版app 安卓取消返回按钮
        if(isAndroid){
          //  console.log("appAndroid",false,false,false)
           window.Android.getBackStatus(false);
        }
        // 海外版app ios取消返回按钮
        if(isiOS){
          // console.log("appIOS",false,false,false)
          window.webkit.messageHandlers.getBackStatus.postMessage(false);
        }
      }
      if (from.path == "/" && to.path == "/")
      {
        this.transitionName = "none";
        return;
      }
      let fromDepth = from.path.split("/").length;
      let toDepth = to.path.split("/").length;
      if (fromDepth == toDepth) {
        this.transitionName =
          to.path.length > from.path.length ? "slide-right" : "slide-left";
      } else {
        this.transitionName =
          toDepth > fromDepth ? "slide-right" : "slide-left";
      }
    }
  },
  methods:{
    loadYoutubeJs()
    {
      // window.localIP = "111.200.218.56" ;//测试国内ip
      // console.log("appCreated iframe",window.localIP)
      // if (window.localIP) 
      // {
        let that = this;
        this.$axios
        // .post("https://www.atoshi.info/intapi/h5/chinaIp", {ip: window.localIP})
        .get(enums.judgeIp, {})
        .then(res => {
          if (res.data && res.data.data) {
            let isChina = res.data.data.isChina;
            // let isChina = true;
            that.$store.commit(SET_IPFROM, isChina);
            if (res.data.data.isChina) {} else {
              let tag = document.createElement('script');
              tag.src = "https://www.youtube.com/iframe_api";
              let firstScriptTag = document.getElementsByTagName('script')[0];
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
          }
        })
        .catch(error=>{
          
        })
      // }
    },
  }
};
</script>

<style>
* {
  -webkit-tap-highlight-color: transparent;
}
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: "lucida grande", "lucida sans unicode", lucida, helvetica,
    "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  font-size: 0.3rem;
}

#welcome {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: cornflowerblue;
}

.child-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  transition: all 0.6s cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(-80px, 0);
  transform: translate(-80px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
body {
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue